// extracted by mini-css-extract-plugin
export default {"button":"KHJ7krvln2Wh8N0Higl8"};